define(["require", "exports", "tslib", "../directives/index", "../filters/index", "./PluginsCustomGlobalFunc", "./PluginsCustomFunc", "./PluginsMixin", "./PluginsCustomFilter", "vue"], function (require, exports, tslib_1, index_1, index_2, PluginsCustomGlobalFunc_1, PluginsCustomFunc_1, PluginsMixin_1, PluginsCustomFilter_1, vue_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PluginsExtened = void 0;
    vue_1 = (0, tslib_1.__importDefault)(vue_1);
    var PluginsExtened = (function () {
        function PluginsExtened() {
            this.customGlobalFunc = new PluginsCustomGlobalFunc_1.PluginsCustomGlobalFunc();
            this.customFunc = new PluginsCustomFunc_1.PluginsCustomFunc();
            this.customMixin = new PluginsMixin_1.PluginsMixin();
        }
        PluginsExtened.prototype.install = function (vue, options) {
            Object.keys(index_1.directives).forEach(function (key) {
                var directivesVal = index_1.directives;
                vue_1.default.directive(key, directivesVal[key]);
            });
            Object.keys(index_2.filters).forEach(function (key) {
                var filtersVal = index_2.filters;
                vue_1.default.filter(key, filtersVal[key]);
            });
            vue.filter('captialize', PluginsCustomFilter_1.capitalize);
        };
        return PluginsExtened;
    }());
    exports.PluginsExtened = PluginsExtened;
});
//# sourceMappingURL=PluginsExtened.js.map